export default "https://cdn-static.gokick.com/assets/adaefb0e3fd6b18bbcda680789a7f58b9251a870/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";